import React, { useState } from 'react';
import './styles/grievance-write-to-us.css';
import '../../common/styles/index.css';
import { trackGrievanceBySRN } from './services/grievanceWriteToUsService';

const GrievanceWriteToUsApp = () => {
  const [srn, setSrn] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [result, setResult] = useState(null);

  const handleSubmit = async () => {
    if (!srn.trim()) {
      setError('Please enter Service Request Number');
      return;
    }

    setError('');
    setResult(null);
    setLoading(true);

    try {
      await trackGrievanceBySRN(srn);

      const encodedSrn = btoa(srn.trim());
      const baseUrl =
        window.Liferay?.ThemeDisplay?.getPortalURL() || '';
      const redirectUrl = `${baseUrl}/grievance?srn=${encodeURIComponent(
        encodedSrn
      )}`;

      window.location.href = redirectUrl;
    } catch (err) {
      setError(err.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="scl-grievance-write-to-us">
      <h1 className="scl-grievance-write-to-us__title">Write to Us</h1>

      <div className="scl-grievance-write-to-us__form">
        <input
          type="text"
          onChange={(e) => setSrn(e.target.value)}
          className="scl-form-input scl-grievance-write-to-us__input"
          placeholder="Service request no."
          value={srn}
        />

        <button
          type="button"
          className="scl-form-btn scl-form-btn--primary"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? 'Please wait...' : 'Submit'}
        </button>

        {error && <p className="scl-form-error">{error}</p>}

        {result && (
          <div className="scl-form-success">
            Grievance details fetched successfully.
          </div>
        )}
      </div>
    </div>
  );
};

export default GrievanceWriteToUsApp;
